export enum FormLabelModeEnum {
  Static = 'static',
  Floating = 'floating',
  Hidden = 'hidden',
  Outside ='outside'
}
